export default "__VITE_ASSET__DmgFd7TP__"